/**
 * Shared constants for group management forms
 */

// Allowed leverage values as specified in requirements
export const ALLOWED_LEVERAGE = [1, 2, 3, 5, 10, 20, 25, 30, 40, 50, 75, 100, 150, 200, 300, 400, 500];

// Category-specific maximum leverage limits
export const CATEGORY_LEVERAGE_LIMITS = {
  stocks: 50,
  crypto: 100,
  indices: 200,
  commodities: 100,
  forex: 500
};

// Helper function to check if a value is in the allowed leverage list
export const isAllowedLeverage = (value) => {
  return ALLOWED_LEVERAGE.includes(value);
};

// Helper function to find the closest allowed leverage value
export const findClosestAllowedLeverage = (value) => {
  if (isAllowedLeverage(value)) {
    return value;
  }
  
  // Find the closest value in the allowed list
  return ALLOWED_LEVERAGE.reduce((prev, curr) => {
    return Math.abs(curr - value) < Math.abs(prev - value) ? curr : prev;
  });
};

// Helper function to get the maximum allowed leverage for a category
export const getMaxAllowedLeverageForCategory = (category) => {
  const categoryMax = CATEGORY_LEVERAGE_LIMITS[category] || 500;
  // Find the highest allowed leverage that doesn't exceed the category max
  return ALLOWED_LEVERAGE.filter(val => val <= categoryMax).pop() || 1;
};